export default __webpack_public_path__ + "static/media/blue-wing-logo.fe446ae1.png";